import { TEMPLATES_CONFIG } from '@/views/autopilot/config/templates.config'

import type { Template } from '@/views/autopilot/config/templates.config'
import type { ChipColor } from '@/components/base/BaseChip.vue'

export default function useTemplates() {
  const { t } = useI18n()

  const templates = computed<Template[]>(() =>
    TEMPLATES_CONFIG.map((template) => ({
      id: template.id,
      type: template.type,
      title: t(template.title),
      icon: template.icon,
      description: t(template.description),
      details: template.details.map((detail) => ({
        title: detail.title ? t(detail.title) : undefined,
        desc_1: t(detail.desc_1),
        desc_2: detail.desc_2 ? t(detail.desc_2) : undefined,
        desc_3: detail.desc_3 ? t(detail.desc_3) : undefined
      })),
      audienceCreationType: template.audienceCreationType,
      isRecommended: template.isRecommended,
      disabled: template.disabled,
      time: template.time,
      tip: template.tip ? t(template.tip) : undefined,
      italic: template.italic ? t(template.italic) : undefined,
      requiresAudienceTemplate: template.requiresAudienceTemplate,
      category: template.category
    }))
  )

  const formattedTemplates = computed<Template[]>(() =>
    templates.value.filter((template) => template.disabled === false)
  )

  const categories = computed<{ id: string; label: string; color: ChipColor }[]>(() => [
    { id: 'all', label: t('pages.autopilot.autopilotsPage.templates.page.filters.all'), color: 'violet' },
    {
      id: 'recommended',
      label: t('pages.autopilot.autopilotsPage.templates.page.filters.recommended'),
      color: 'violet'
    },
    {
      id: 'attract_convert',
      label: t('pages.autopilot.autopilotsPage.templates.page.filters.attract_convert'),
      color: 'violet'
    },
    {
      id: 'retain_reward',
      label: t('pages.autopilot.autopilotsPage.templates.page.filters.retain_reward'),
      color: 'violet'
    },
    {
      id: 'reactivate_reengage',
      label: t('pages.autopilot.autopilotsPage.templates.page.filters.reactivate_reengage'),
      color: 'violet'
    }
  ])

  const getTitleByType = (type: string) => {
    return templates.value.find((template) => template.type === type)?.title
  }

  const getTitleByCategory = (category: string) => {
    return categories.value.find((categoryItem) => categoryItem.id === category)?.label
  }

  return {
    categories,
    templates: formattedTemplates,
    getTitleByType,
    getTitleByCategory
  }
}
